import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Modal, Button } from 'react-bootstrap';
import Tabs from '../components/ui/Tabs';
import GeneralInfoForm from '../components/forms/GeneralInfoForm';
import '../styles/EmployeeMaster.css';
import SubmodClassTable from '../components/SubmodClassTable';

const SubmodClass = () => {
  const [employees, setEmployees] = useState([]);
  const navigate = useNavigate();
  const location = useLocation();

  const showModal = location.pathname === '/submodClass/add';

  const handleAddClick = () => {
    
    navigate('/submodClass/add');
  };

  const handleCloseModal = () => {
    navigate('/submodClass');
  };

  return (
    <div className="employee-master-page">
      <div className="employee-header">
        <h2>SubmodClass Master</h2>
        <button className="add-employee-btn" onClick={handleAddClick}>
          Add SubmodClass
        </button>
      </div>

      <SubmodClassTable />
    </div>
  );
};

export default SubmodClass;